import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getSubProductsOfProducts = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IGetThisYearCultivations[]} = await request.get(
    `/api/v2/farm/subproducts-of-product?product=${ctx.queryKey[1]}`,
  );
  return data;
};

export const patchSubProduct = async (payload: IPatchSubProductPayload) => {
  const response = await request.patch(`/api/v2/farm/cultivation`, {
    cultivation_guid: payload.cultivation_guid,
    subproduct_guid: payload.subproduct_guid,
  });
  return response;
};
